import { mixins } from './index';

export const menuWidth = '240px';
export const menuWidthTablet = '40px';
export const iconSizeM = '24px';

const fontCommon = {
  fontFamily: mixins.systemFontStack,
  // '-webkit-font-smoothing': 'antialiased',
};

export const fontNormal400 = { ...fontCommon, fontWeight: 400 };
export const fontBold700 = { ...fontCommon, fontWeight: 700 };

const breakpoints = {
  md: 768,
  lg: 1024,
};

export const mediaBreakPointUp = {
  md: `@media (min-width: ${breakpoints.md}px)`,
  lg: `@media (min-width: ${breakpoints.lg}px)`,
};

export const fontSizes = {
  xxs: '12px',
  xs: '13px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '24px',
  xxl: '32px',
};

export const palette = {
  purple: '#504388',
  purpleDark: '#261753',
  gray: '#B6BBC4',
  orange: '#EB830E',
  orangeDark: '#C16D0F',
  brown: '#B58B52',
  black: '#050404',
  dtGray: '#222222',
  dtBlack: '#181818',
  white: '#F4F4F4',
};
export const lightPalette = {
  purple: '#504388',
  purpleDark: '#261753',
  gray: '#B6BBC4',
  orange: '#EB830E',
  orangeDark: '#C16D0F',
  brown: '#B58B52',
  black: '#050404',
  white: '#F4F4F4',
};

export const darkPalette = {
  purple: '#504388',
  purpleDark: '#261753',
  gray: '#222222',
  orange: '#EB830E',
  orangeDark: '#C16D0F',
  brown: '#B58B52',
  black: '#181818',
  white: '#F4F4F4',
};
